<template>
    <div class="investors">
        <div class="investors__image"></div>
        <div class="investors__col">
            <div class="investors__content">
                <stock-data></stock-data>
            </div>
            <div class="investors__article">
                <h2 class="investors__header">{{title}}</h2>
                <p class="investors__text">{{text}}</p>
                <z-button tag="a" :href="`/${$root.lang}/investors/key-figures/`" kind="text">
                    {{button}}
                    <template v-slot:right>
                        <z-icon
                            name="arrow_long"
                            dir="right"
                            width="40"
                            height="24"
                        ></z-icon>
                    </template>
                </z-button>
            </div>
        </div>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'hp-investors',
    data () {
        return {
            title: localize({
                ru: 'инвесторам',
                en: 'investors'
            }),
            text: localize({
                ru: 'Мы стремимся установить и поддерживать отношения между ПАО «Распадская» и нашими существующими и потенциальными инвесторами для того, чтобы помочь им сформировать объективное мнение относительно стоимости Распадской на наилучшей основе. Наша приоритетная задача в этой связи — наиболее полно удовлетворять потребности заинтересованных лиц в достоверной информации о компании и ее деятельности.',
                en: 'We strive to establish and maintain relations between the Company and its existing and potential investors in order to help them form a fair view about Raspadskaya’s value on the best possible basis. Our priority in this respect is the supply of comprehensive information about the company and its activities to the capital market.'
            }),
            button: localize({
                ru: 'Ключевые показатели',
                en: 'Key Figures'
            })
        }
    }

}
</script>

<style lang="scss">
    .investors {
        display: flex;

        @include breakpoint (mobile) {
            flex-direction: column;
        }

        &__image {
            background-image: url('/images/investors.jpg');
            background-position: center;
            background-size: cover;
            flex: 0 0 56%;
            height: 0;
            padding-top: 37%;

            @include breakpoint (tablet) {
                flex: 0 0 37%;
                padding-top: 31%;
            }

            @include breakpoint (v-tablet) {
                padding-top: 60%;
            }

            @include breakpoint (mobile) {
                padding-top: 89%;
            }
        }

        &__content {
            padding: 38px 0 46px 38px;

            @include breakpoint (v-tablet) {
                padding: $token-spacers-xs;
            }
        }

        &__article {
            padding: $token-spacers-2-xl;
            background-color: $token-colors-black-5;
            transform: translate(-80px, 0);
            margin-right: -80px;
            box-shadow: 0 100px 80px rgba(55, 56, 58, 0.07), 0 42px 33px rgba(55, 56, 58, 0.05), 0 22px 18px rgba(55, 56, 58, 0.0417275), 0 13px 10px rgba(55, 56, 58, 0.035), 0 7px 5px rgba(55, 56, 58, 0.03), 0 3px 2px rgba(55, 56, 58, 0.02);

            @include breakpoint (tablet) {
                transform: translate(-80px, 0);
                padding: $token-spacers-s;
            }

            @include breakpoint (mobile) {
                transform: none;
                margin-right: 0;
                padding: $token-spacers-s $token-spacers-2-xs;
            }
        }

        &__col {
            max-width: 44%;
            display: flex;
            flex-direction: column;

            @include breakpoint (tablet) {
                max-width: 68%;
            }

            @include breakpoint (mobile) {
                order: -1;
                max-width: initial;
                width: 100%;
            }
        }

        &__header {
            font-weight: 900;
            font-size: 90px;
            line-height: 120%;
            text-transform: uppercase;
            color: $token-colors-black-80;
            @include margin-level(bottom, S);

            @include breakpoint (laptop) {
                font-size: 50px;
            }

            @include breakpoint (tablet) {
                font-size: 40px;
                @include margin-level(bottom, XS);
            }

            @include breakpoint (v-tablet) {
                font-size: 32px;
            }

            @include breakpoint (mobile) {
                font-size: 28px;
                @include margin-level(bottom, 2XS);
            }
        }

        &__text {
            font-size: 24px;
            line-height: 140%;
            font-weight: 500;
            color: $token-colors-text-default;
            @include margin-level(bottom, S);

            @include breakpoint (tablet) {
                @include margin-level(bottom, XS);
                font-weight: 500;
                font-size: 18px;
                line-height: 140%;
            }

            @include breakpoint (mobile) {
                font-size: 14px;
                @include margin-level(bottom, 2XS);
            }
        }
    }
</style>
